<template>
    <div id="print-song">
        <song></song>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import store from '@/stores';
import * as types from '@/stores/types';
import Song from '@/components/Song.vue';

export default {
    name:       'print-song',
    store:      store,
    components: {
        Song,
    },
    mounted: function()
    {
        // On désactive le mode édition
        // ----------------------------
        if (this.editionMode)
        {
            this.toggleEditionMode();
        }

        // Impression
        // ----------
        window.print();

        // Fermeture de la fenêtre
        // -----------------------
        window.onafterprint = function()
        {
            window.close();
        };
    },
    computed: {
        ...mapGetters({
            editionMode:  'editionMode',
        }),
    },
    methods: {
        ...mapActions({
            toggleEditionMode: types.A_SONG_TOGGLE_EDITION_MODE,
        }),
    },
};
</script>

<style scoped lang="scss">
    #print-song {
        width: 100%;
    }
</style>
